<template>
	<div class="doctorPage managerPlan Manager">
		<div class="selectSearch" v-if="!splitScreen">
			<el-form ref="form" class="qcFrom searchConditions" :inline="true">
				<div v-if="userParameter.ExpertFromType!=4">
					<el-form-item class="placeholders1" label="关键词">
						<el-input v-model="pages.name" class="name" size="mini" placeholder="姓名/手机号"></el-input>
					</el-form-item>
					<el-form-item label="专家专业" prop="ExpertMajor">
						<el-select size="mini" v-model="userParameter.ExpertMajor" placeholder="请选择专业">
							<el-option v-for="item in detailsRulesParameter.ExpertMajor" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item label="专家来源" prop="ExpertFromType">
						<el-select size="mini" v-model="userParameter.ExpertFromType" placeholder="请选择来源">
							<el-option v-for="item in detailsRulesParameter.ExpertFromType" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="专家分组" prop="ExpertLevelType">
						<el-select size="mini" v-model="userParameter.ExpertLevelType" placeholder="请选择专家分组">
							<el-option key="1" label="甲" value="甲"></el-option>
							<el-option key="2" label="乙" value="乙"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="擅长设备" prop="ModalityTypes">
						<el-select size="mini" v-model="userParameter.ModalityTypes" filterable placeholder="请选择擅长设备">
						    <el-option
						      v-for="item in detailsRulesParameter.modalityType"
						      :key="item.text" :label="item.text" :value="item.text">
						    </el-option>
						  </el-select>
					</el-form-item>
					<el-form-item label="擅长部位" prop="Bodyparts">
						<el-select size="mini" v-model="userParameter.Bodyparts" filterable placeholder="请选择擅长部位">
						    <el-option
						      v-for="item in detailsRulesParameter.BodyPart"
						      :key="item.text" :label="item.text" :value="item.text">
						    </el-option>
						  </el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="search">查询</el-button>
						<el-button type="primary" class="resetBtn" @click="resetForm('form')">重置</el-button>
					</el-form-item>
				</div>
				<div v-else>
					<el-form-item label="姓名">
						<el-input v-model="pages.name" class="name" size="mini" placeholder="姓名"></el-input>
					</el-form-item>
					<el-form-item label="创建时间" v-if="userParameter.ExpertFromType==4">
						<el-date-picker class="time mar4" 
						v-model="expertJobCountArr.dataArr" 
						type="monthrange"
						 @change="datePickerMonth" 
						 size="mini" 
						 :clearable="false"
						 range-separator="~" 
						 value-format="yyyy/MM"
						 start-placeholder="开始时间" 
						 end-placeholder="结束时间" >
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="search">查询</el-button>
					</el-form-item>
				</div>
				<div v-if="routers.indexOf('workingteam')>-1 && userParameter.ExpertFromType!=4">
					<el-form-item label="创建时间">
						<el-date-picker class="time mar4" 
						v-model="pickerDate.date" 
						type="daterange" 
						@change="datePicker" 
						size="mini" 
						range-separator="~" 
						value-format="yyyy/MM"
						start-placeholder="开始时间" 
						end-placeholder="结束时间">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="search">查询</el-button>
					</el-form-item>
				</div>
				<a href="javascript:;" class="addbtn" @click="showNewWorking" v-if="routers.indexOf('workingteam')>-1&&userParameter.ExpertFromType!=4">新建工作组</a>
				<!-- <a href="javascript:;" class="addbtn" @click="showSpecialist" v-if="routers.indexOf('specialist')>-1&&userParameter.ExpertFromType!=4">新建专家</a> -->
				<a href="javascript:;" class="addbtn" @click="exportExcel" v-if="routers.indexOf('workload')>-1">导出</a>
			</el-form>
		</div>
		<!-- 中间内容 -->
		<div class="centerHome" :class="splitScreen?'centerHomeActive':''">
			<div class="closeSplitScreen el-icon-circle-close" v-if="splitScreen" @click="closeSplitScreen"></div>
			<div class="ccHomel" v-if="!splitScreen">
				<div class="compentTable">
					<div v-if="routers.indexOf('workingteam')>-1">
						<working-team-table/>
					</div>
					<div v-if="routers.indexOf('workingteam')>-1==false&&routers.indexOf('workload')>-1==false">
						<specialist-table/>
					</div>
					<div v-if="routers.indexOf('workload')>-1">
						<expertjobcount-table/>
					</div>

					<div class="pages">
						<el-pagination class="pageAll" layout="prev, pager, next" :total="total" :page-size='pages.pageCount' :current-page='pages.pageIndex' @current-change='currentChange'>
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Api from '../../../api'
	import axios from '@/js/api'
	import { mapState, mapActions, mapMutations } from 'vuex'
	import workingTeamTable from '../../../components/specialist/workingTeamTable.vue'
	import specialistTable from '../../../components/specialist/specialistTable.vue'
	import expertjobcountTable from '../../../components/specialist/expertjobcountTable.vue'
	export default {
		data() {
			return {
				setDate: '',
				routers: ''
			}
		},
		components: {
			workingTeamTable,
//			newWorkingTeamDetails,
			specialistTable,
//			newSpecialistDetails,
			expertjobcountTable
		},
		watch: {
			$route(to, from) {
				//初始化
				this.clearInit()
				this.setRouter(to.path);
				this.routers = to.path;
			}
		},
		computed: {
			...Vuex.mapState('managerUser', ['pages', 'splitScreen', 'userParameter', 'total', 'isscreen', 'newWorkTeamFrom', 'pickerDate','expertJobCountArr','loading', 'detailsRulesParameter']),
			...Vuex.mapState('doctor', ['DashboradArr'])
		},
		activated() {
			this.GetBodyParts()
			this.GetReportModality()
			this.clearUserParameter()
			this.$nextTick(function() {
				this.clearexpertJobCountArr();
				this.routers = this.$route.path;
				// console.log('this.routers', this.routers, this.routers.indexOf('workingteam')>-1)
				this.setRouter(this.$route.path)
			})
		},
		methods: {
			...Vuex.mapMutations('managerUser', ['clearexpertJobCountArr','clearUserParameter','currentChanges', 'clearInit', 'setIsscreen', 'setDatePicker', 'setSplitScreen', 'clearNewWorkTeamFrom', 'setUserFromType', 'clearexpertInfoUpdateArr','setLoading']),
			...Vuex.mapActions('managerUser', ['userlist', 'GetExpertGroupList','GetExpertJobCount','GetBodyParts','GetReportModality']),
			// 重置
			resetForm(formName) {
				//初始化
				this.clearUserParameter()
				this.search()
			},
			//设置路由
			setRouter(to) {
				this.setLoading(true);
				this.setSplitScreen(false)
				if(to.indexOf('specialist') > -1) {
					this.setIsscreen('specialist')
					this.userlist()
				}
				if(to.indexOf('workload') > -1) {
					this.setUserFromType(4);
					if (this.expertJobCountArr.dataArr!=null&&this.expertJobCountArr.dataArr!=undefined&&this.expertJobCountArr.dataArr!='') {
						this.expertJobCountArr.startdt = this.expertJobCountArr.dataArr[0];
						this.expertJobCountArr.enddt = this.expertJobCountArr.dataArr[1];
					}
					this.expertJobCountArr.name = this.pages.name;
					this.GetExpertJobCount();
				}
				if(to.indexOf('workingteam') > -1) {
					this.setIsscreen('workingteam')
					this.GetExpertGroupList()

				}

			},
			//分页
			currentChange(val) {
				this.setLoading(true);
				this.currentChanges(val)
				this.setRouter(this.routers)
				document.body.scrollTop = document.documentElement.scrollTop = 0;
			},
			//搜索
			search() {
				this.setLoading(true);
				this.pages.pageCount = 10;
				this.currentChanges(1)
				this.setRouter(this.routers)
			},
			//创建日期
			datePicker(event) {
				this.setDatePicker(event)
			},
			datePickerMonth(event){
				if(event){
					this.expertJobCountArr.startdt = event[0];
					this.expertJobCountArr.enddt = event[1];
				}else{
					this.expertJobCountArr.startdt = '';
					this.expertJobCountArr.enddt = '';
				}
			},
			//关闭分屏
			closeSplitScreen() {
				this.setLoading(false);
				this.pages.pageCount = 10;
				this.setSplitScreen(false)
				this.setRouter(this.routers)
			},
			//工作组
			showNewWorking() {
				this.setLoading(true);
//				this.setSplitScreen(true);
				this.clearNewWorkTeamFrom();
				this.userlist();
				this.$router.push('/home/manager/newWorkingTeamDetails')
			},
			//专家
			showSpecialist() {
//				this.setSplitScreen(true);
				this.clearexpertInfoUpdateArr();
				this.$router.push("/home/specialist/newSpecialistDetails")
			},
			exportExcel(){
				window.location.href = axios.exportExcel(Api.api.specialist.GetExpertJobCount)+"?startdt="+this.expertJobCountArr.dataArr[0]+"&enddt="+this.expertJobCountArr.dataArr[1]+"&exportExcel=true&userGuid="+JSON.parse(localStorage.getItem('user')).sid;
			},
			//  //评分细则显示详情
			//  showDetails(){
			//       this.setSplitScreen(true)
			//       this.clearRulesFrom();
			//  },
			//  //评分方案显示详情
			//  showSchemeDetails(){
			//     this.setSplitScreen(true)
			//  },

		}

	}
</script>